import domReady from '@wordpress/dom-ready';

domReady(() => {
  const indiceBar = document.querySelector('#risk-indice-bar');

  if (indiceBar) {
    const result = indiceBar.getAttribute('data-result');
    const total = 93;
    const percentage = (100 * result) / total;
    const resultItem = indiceBar.querySelector('.indice-bar__result .result');

    function isInViewport(element) {
      const bounding = element.getBoundingClientRect();

      if (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right <=
          (window.innerWidth || document.documentElement.clientWidth) &&
        bounding.bottom <=
          (window.innerHeight || document.documentElement.clientHeight)
      ) {
        return true;
      }

      return false;
    }

    function adjustPercentage() {
      if (isInViewport(resultItem)) {
        resultItem.style.left = percentage + '%';
        window.removeEventListener('scroll', adjustPercentage);
      }
    }

    window.addEventListener('scroll', adjustPercentage, false);

    adjustPercentage();
  }
});
